import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  CardHeader,
  Avatar,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useTheme,
  Grid
} from '@mui/material';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ConstructionIcon from '@mui/icons-material/Construction';
import ChecklistIcon from '@mui/icons-material/Checklist';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';

import { useTranslation } from 'react-i18next';

// Culori pastel diferite pentru fiecare serviciu
const avatarColors = ['#42a5f5', '#42a5f5', '#42a5f5', '#42a5f5'];

const services = (t) => [
  {
    icon: <ConstructionIcon fontSize="inherit" />,
    title: t('services.contract.title'),
    description: t('services.contract.description'),
    examples: t('services.contract.examples', { returnObjects: true }),
  },
  {
    icon: <ChecklistIcon fontSize="inherit" />,
    title: t('services.quality.title'),
    description: t('services.quality.description'),
    examples: t('services.quality.examples', { returnObjects: true }),
  },
  {
    icon: <HistoryEduIcon fontSize="inherit" />, // Schimbat din MuseumIcon în HistoryEduIcon
    title: t('services.archaeology.title'),
    description: t('services.archaeology.description'),
    examples: t('services.archaeology.examples', { returnObjects: true }),
  },
  {
    icon: <ElectricalServicesIcon fontSize="inherit" />,
    title: t('services.lowCurrent.title'),
    description: t('services.lowCurrent.description'),
    examples: t('services.lowCurrent.examples', { returnObjects: true }),
  }
];

export default function Services() {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        background: 'linear-gradient(180deg, #f0f4ff, #ffffff)',
        py: { xs: 6, md: 10 }
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h3" fontWeight="bold" sx={{ mb: 2, color: theme.palette.primary.main }}>
            {t('services.title')}
          </Typography>
          <Typography variant="h6" sx={{ color: 'text.secondary', maxWidth: 700, mx: 'auto' }}>
            {t('services.subtitle')}
          </Typography>
        </Box>

        <Grid container direction="column" spacing={4}>
          {services(t).map((service, index) => (
            <Grid item key={index}>
              <Card
                elevation={0}
                sx={{
                  borderRadius: 5,
                  background: 'rgba(255, 255, 255, 0.9)',
                  backdropFilter: 'blur(6px)',
                  p: 4,
                  boxShadow: '0 12px 28px rgba(0, 0, 0, 0.05)',
                  transition: '0.3s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 18px 36px rgba(0, 0, 0, 0.08)'
                  }
                }}
              >
                <CardHeader
                  avatar={
                    <Avatar
                      sx={{
                        bgcolor: avatarColors[index % avatarColors.length],
                        width: 60,
                        height: 60,
                        fontSize: 32,
                        color: '#fff'
                      }}
                    >
                      {service.icon}
                    </Avatar>
                  }
                  title={
                    <Typography variant="h5" fontWeight="bold" color={theme.palette.text.primary}>
                      {service.title}
                    </Typography>
                  }
                  subheader={
                    service.description && (
                      <Typography variant="body1" color="text.secondary">
                        {service.description}
                      </Typography>
                    )
                  }
                />

                <Divider sx={{ my: 3 }} />

                <CardContent sx={{ px: 0 }}>
                  {service.examples.map((example, i) => (
                    <Accordion
                      key={i}
                      disableGutters
                      elevation={0}
                      sx={{
                        backgroundColor: '#f9faff',
                        mb: 1.5,
                        borderRadius: 2,
                        border: '1px solid #e0e6f5',
                        '&:before': { display: 'none' },
                        transition: 'background-color 0.2s',
                        '&:hover': {
                          backgroundColor: '#eef3ff'
                        }
                      }}
                    >
                      <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: theme.palette.primary.main }} />}>
                        <Typography variant="body1" fontWeight={600} color={theme.palette.text.primary}>
                          {example.title}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <ul style={{ margin: 0, paddingLeft: '1.5rem' }}>
                          {example.details.map((detail, j) => (
                            <li key={j} style={{ marginBottom: 6 }}>
                              <Typography variant="body2" color="text.secondary">
                                {detail}
                              </Typography>
                            </li>
                          ))}
                        </ul>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
